import { BrowserRouter as Router, Route, Routes, Navigate, useParams } from 'react-router-dom';
import './App.css';
import Home from './components/Home';
import Logistic from './components/Logistic';
import ShipForSale from './components/ShipForSale';
import RegisterShip from './components/RegisterShip';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import Cargo from './components/Types of ships/Cargo';
import Barge from './components/Types of ships/Barge';
import Bulk from './components/Types of ships/Bulk';
import Container from './components/Types of ships/Container';
import Fishing from './components/Types of ships/Fishing';
import Multipurpose from './components/Types of ships/Multipurpose';
import PassengerFerry from './components/Types of ships/PassengerFerry';
import Reefer from './components/Types of ships/Reefer';
import Roro from './components/Types of ships/Roro';
import Tanker from './components/Types of ships/Tanker';
import Tug from './components/Types of ships/Tug';
import Dredger from './components/Types of ships/Dredger';
import FloatingCrane from './components/Types of ships/FloatingCrane';
import LandingCraft from './components/Types of ships/LandingCraft';
import Yacht from './components/Types of ships/Yacht';
import SupplyBoat from './components/Types of ships/SupplyBoat';
import CrewBoat from './components/Types of ships/CrewBoat';
import Others from './components/Types of ships/Others';
import SingleShip from './components/SingleShip';
import AboutUs from './components/AboutUs';
import ContactUs from './components/ContactUs';
import ShipReadyToChart from './components/ShipReadyToChart';
import ShipLocation from './components/ShipLocation';
import Signin from './components/Admin/Signin';
import AdminDashboard from './components/Admin/AdminDashboard';
import AddShip from './components/Admin/AddShip';
import ViewShip from './components/Admin/ViewShip';
import AddCategory from './components/Admin/AddCategory';
import ViewCategory from './components/Admin/ViewCategory';
import AddSubCategory from './components/Admin/AddSubCategory';
import ViewSubCat from './components/Admin/ViewSubCat';
import UpdateSubCategory from './components/Admin/UpdateSubCategory';
import UpdaetViewShip from './components/Admin/UpdateViewShip';
import VieRegisterShipForSale from './components/Admin/VieRegisterShipForSale';
import ViewShipForCharter from './components/Admin/ViewShipForCharter';
import ViewShipForEquipments from './components/Admin/ViewShipForEquipments';
import Amenities from './components/Admin/Amenities';
import Profile from './components/Admin/Profile';

import SingleShipHome from './components/SingleShipHome';
import SingleShipCharter from './components/SingleShipCharter';
import SingleShipLogistic from './components/SingleShipLogistic';
import PageTransition from './components/PageTransition';
import RegistrationForm from './components/RegistrationForm';
import SingleShipReg from './components/SingleShipReg';
import SingleRegShipForSale from './components/SingleRegShipForSale';
import UpdateViewShipCustomerRegister from './components/Admin/UpdateViewShipCustomerRegister';
import SingleShipCharterReg from './components/SingleShipCharterReg';
import SingleShipLogisticReg from './components/SingleShipLogisticreg';
import SupplyEquipments from './components/SupplyEquipments';
import FloatingDock from './components/Types of ships/FloatingDock';
import Deck from './components/Supply Equipments/Deck';
import RegisterShipForSale from './components/Registrations/RegisterShipForSale';
import RegisterShipForCharter from './components/Registrations/RegisterShipForCharter';
import RegisterLogistics from './components/Registrations/RegisterLogistics';
import RegisterSupplyEquipments from './components/Registrations/RegisterSupplyEquipments';
import EngineStore from './components/Supply Equipments/EngineStore';
import Cabin from './components/Supply Equipments/Cabin';
import NavigationEQ from './components/Supply Equipments/NavigationEQ';
import ValvePipe from './components/Supply Equipments/ValvePipe';
import Cranes from './components/Supply Equipments/Cranes';
import Pumps from './components/Supply Equipments/Pumps';
import MainEngine from './components/Supply Equipments/MainEngine';
import Generator from './components/Supply Equipments/Generator';
import LubeOil from './components/Supply Equipments/LubeOil';
import AddCharter from './components/Admin/AddCharter';
import AddEq from './components/Admin/AddEq';
import ShipForChartApp from './components/Admin/ShipForChartApp';
import ShipForEqApp from './components/Admin/ShipForEqApp';
import BargeA from './components/Admin/Choose Vessel/BargeA';
import BulkA from './components/Admin/Choose Vessel/BulkA';
import CargoA from './components/Admin/Choose Vessel/CargoA';
import ContainerA from './components/Admin/Choose Vessel/ContainerA';
import FishingA from './components/Admin/Choose Vessel/FishingA';
import MultipurposeA from './components/Admin/Choose Vessel/MultipurposeA';
import PassengerFerryA from './components/Admin/Choose Vessel/PassengerFerryA';
import ReeferA from './components/Admin/Choose Vessel/ReeferA';
import RoroA from './components/Admin/Choose Vessel/RoroA';
import TankerA from './components/Admin/Choose Vessel/TankerA';
import DredgerA from './components/Admin/Choose Vessel/DredgerA';
import FloatingCraneA from './components/Admin/Choose Vessel/FloatingCraneA';
import FloatingDockA from './components/Admin/Choose Vessel/FloatingDockA';
import LandingCraftA from './components/Admin/Choose Vessel/LandingCraftA';
import YatchA from './components/Admin/Choose Vessel/YatchA';
import TugBoatA from './components/Admin/Choose Vessel/TugBoatA';
import SupplyBoatA from './components/Admin/Choose Vessel/SupplyBoatA';
import CrewBoatA from './components/Admin/Choose Vessel/CrewBoatA';
import OtherA from './components/Admin/Choose Vessel/OtherA';
import UpdateCharter from './components/Admin/UpdateCharter';
import Signup from './components/Admin/Signup';
import AdminHome from './components/Admin/AdminHome/AdminHome';
import AdminShipForSale from './components/Admin/AdminHome/AdminShipForSale';
import AdminSingleShip from './components/Admin/AdminHome/AdminSingleShip';
import AdminSingleShipForSale from './components/Admin/AdminHome/AdminSingleShipForSale';
import AdminCharter from './components/Admin/AdminHome/AdminCharter';
import AdminSingleCharter from './components/Admin/AdminHome/AdminSingleCharter';
import AdminLogistic from './components/Admin/AdminHome/AdminLogistic';
import AdminSupplyEq from './components/Admin/AdminHome/AdminSupplyEq';

import AdminCargo from './components/Admin/AdminHome/AdminTypes of Ships/AdminCargo';
import AdminSingleShipHome from './components/Admin/AdminHome/AdminSingleShipHome';
import AdminSingleRegHome from './components/Admin/AdminHome/AdminSingleRegHome';
import AdminBarge from './components/Admin/AdminHome/AdminTypes of Ships/AdminBarge';
import AdminBulk from './components/Admin/AdminHome/AdminTypes of Ships/AdminBulk';
import AdminContainer from './components/Admin/AdminHome/AdminTypes of Ships/AdminContainer';
import AdminFishing from './components/Admin/AdminHome/AdminTypes of Ships/AdminFishing';
import AdminMultipurpose from './components/Admin/AdminHome/AdminTypes of Ships/AdminMultipurpose';
import AdminPassengerFerry from './components/Admin/AdminHome/AdminTypes of Ships/AdminPassengerFerry';
import AdminReefer from './components/Admin/AdminHome/AdminTypes of Ships/AdminReefer';
import AdminRoRo from './components/Admin/AdminHome/AdminTypes of Ships/AdminRoRo';
import AdminTanker from './components/Admin/AdminHome/AdminTypes of Ships/AdminTanker';
import AdminTug from './components/Admin/AdminHome/AdminTypes of Ships/AdminTug';
import AdminDredger from './components/Admin/AdminHome/AdminTypes of Ships/AdminDredger';
import AdminFloatingCrane from './components/Admin/AdminHome/AdminTypes of Ships/AdminFloatingCrane';
import AdminFloatingDock from './components/Admin/AdminHome/AdminTypes of Ships/AdminFloatingDock';
import AdminLandingCraft from './components/Admin/AdminHome/AdminTypes of Ships/AdminLandingCraft';
import AdminYacht from './components/Admin/AdminHome/AdminTypes of Ships/AdminYacht';
import AdminSupplyBoat from './components/Admin/AdminHome/AdminTypes of Ships/AdminSupplyBoat';
import AdminCrewBoat from './components/Admin/AdminHome/AdminTypes of Ships/AdminCrewBoat';
import AdminOthers from './components/Admin/AdminHome/AdminTypes of Ships/AdminOthers';
import UserHome from './components/UserHome/UserHome';
import UserShipForSale from './components/UserHome/UserShipForSale';
import Plans from './components/Plans/PremiumPack.jsx';
import PremiumPack from './components/Plans/PremiumPack.jsx';
import UserShipReadyToChart from './components/UserHome/UserShipReadyToChart.jsx';
import UserLogistics from './components/UserHome/UserLogistics.jsx';
import UserSupplyEQ from './components/UserHome/UserSupplyEQ.jsx';
import UserContactUs from './components/UserHome/UserContactUs.jsx';
import UserProfileUpdate from './components/UserHome/UserProfileUpdate.jsx';
import UserDashboard from './components/UserHome/UserDashboard.jsx';
import UserMyListing from './components/UserHome/UserMyListing.jsx';
import PrivacyPoicy from './components/PrivacyPolicy.jsx';
import AdminContactUs from './components/Admin/AdminHome/AdminContactUs.jsx';
import RegisterShipForSaleAdmin from './components/Admin/AdminHome/RegisterShipForSaleAdmin.jsx';
import RegisterAdmin from './components/Admin/AdminHome/RegisterAdmin.jsx';
import RegisterShipForCharterAdmin from './components/Admin/AdminHome/RegisterShipForCharterAdmin.jsx';
import UserBarge from './components/UserHome/User Types of ships/UserBarge.jsx';
import UserBulk from './components/UserHome/User Types of ships/UserBulk.jsx';
import UserCargo from './components/UserHome/User Types of ships/UserCargo.jsx';
import UserContainer from './components/UserHome/User Types of ships/UserContainer.jsx';
import UserFishing from './components/UserHome/User Types of ships/UserFishing.jsx';
import UserMultipurpose from './components/UserHome/User Types of ships/UserMultipurpose.jsx';
import UserPassengerFerry from './components/UserHome/User Types of ships/UserPassengerFerry.jsx';
import UserReefer from './components/UserHome/User Types of ships/UserReefer.jsx';
import UserRoro from './components/UserHome/User Types of ships/UserRoro.jsx';
import UserTanker from './components/UserHome/User Types of ships/UserTanker.jsx';
import UserDredger from './components/UserHome/User Types of ships/UserDredger.jsx';
import UserFloatingCrane from './components/UserHome/User Types of ships/UserFloatingCrane.jsx';
import UserFloatingDock from './components/UserHome/User Types of ships/UserFloatingDock.jsx';
import UserLandingCraft from './components/UserHome/User Types of ships/UserLandingCraft.jsx';
import UserYacht from './components/UserHome/User Types of ships/UserYacht.jsx';
import UserTug from './components/UserHome/User Types of ships/UserTug.jsx';
import UserSupplyBoat from './components/UserHome/User Types of ships/UserSupplyBoat.jsx';
import UserCrewBoat from './components/UserHome/User Types of ships/UserCrewBoat.jsx';
import UserOthers from './components/UserHome/User Types of ships/UserOthers.jsx';
import ResetPassword from './components/ResetPassword.jsx';
import RegistrationFormCharter from './components/Registrations/RegistrationFormCharter.jsx';
import LogisticsApprov from './components/Admin/LogisticsApprov.jsx';
import AutomationRegisterLogistics from './components/Registrations/AutomationRegisterLogistics.jsx';
import UpdateLogistic from './components/Admin/UpdateLogistic.jsx';
import AddCargo from './components/Admin/AddCargo.jsx';
import ViewCargo from './components/Admin/ViewCargo.jsx';
import RegisterPurchaseQuery from './components/Registrations/RegisterPurchaseQuery.jsx';
import Map from './components/Map.jsx';

import 'leaflet/dist/leaflet.css';
import TermsAndService from './components/TermsAndService.jsx';
import CargoMap from './components/CargoMap.jsx';
import AllUsers from './components/Admin/AllUsers.jsx';
import NewHome from './components/NewHome.jsx';



function App() {
const RedirectWithParams = () => {
  const { id } = useParams();
  return <Navigate to={`/ship-for-sale/${id}`} replace />;
};
  return (
    <>
      <ToastContainer/>
      <Router>
      
        <Routes>
          <Route path="/reset-password/:uidb64/:token" element={<ResetPassword />} />
          <Route path='/' element={<NewHome/>} />
          <Route path='/newhome' element={<NewHome/>} />

          <Route path='/ship-for-sale' element={<ShipForSale/>} />
          <Route path="/shipforsale" element={<Navigate to="/ship-for-sale" replace />} />

          <Route path='/open-cargo' element={<Logistic/>} />
          <Route path='/logistics'element={<Navigate to="/open-cargo" replace />} />

          <Route path='/ship-chartering' element={<ShipReadyToChart/>} />
          <Route path='/shipreadytochart'element={<Navigate to="/ship-chartering" replace />} />

          <Route path='/privacypolicy' element={<PrivacyPoicy/>} />
          
          <Route path='/termsandservices' element={<TermsAndService/>} />

          <Route path='/map/ship-chartering' element={<Map/>} />
          <Route path='/map/open-cargo' element={<CargoMap/>} />


          <Route path='/premium' element={<PremiumPack/>} />
          
          <Route path='/supplyEq' element={<SupplyEquipments/>} />
          {/* automation forms */}
          <Route path='/automationRegForm' element={<RegistrationForm/>} />
          <Route path='/automationRegFormcharter' element={<RegistrationFormCharter/>} />
          <Route path='/automationRegFormLogistics' element={<AutomationRegisterLogistics/>}  />
          
            {/* Register Button for user */}
          <Route path='/regShip' element={<RegisterShip/>} />
          <Route path='/regShipforsale' element={<RegisterShipForSale/>} />
          <Route path='/regShipforcharter' element={<RegisterShipForCharter/>} />
          <Route path='/reglogistic' element={<RegisterLogistics/>} />
          <Route path='/regsupplyeq' element={<RegisterSupplyEquipments/>} />
          <Route path='/regPurchaseQuery' element={<RegisterPurchaseQuery/>} />

          {/*  Register Button for Admin */}
          <Route path='/regShipadmin' element={<RegisterAdmin/>} />
          <Route path='/regShipforsaleadmin' element={<RegisterShipForSaleAdmin/>} />
          <Route path='/regShipforcharteradmin' element={<RegisterShipForCharterAdmin/>} />

        

          {/* User Home side */}
          <Route path='/userHome' element={<UserHome/>}/>
          <Route path='/userShipForSale' element={<UserShipForSale/>}/>
          <Route path='/usershipreadytochart' element={<UserShipReadyToChart/>}/>
          <Route path='/userlogistics' element={<UserLogistics/>}/>
          <Route path='/usersupplyEq' element={<UserSupplyEQ/>}/>
          <Route path='/usercontact' element={<UserContactUs/>}/>
          
          <Route path='/userDashboard' element={<UserDashboard/>}/>
          <Route path='/userlist' element={<UserMyListing/>}/>
          <Route path='/userprofile' element={<UserProfileUpdate/>}/>

           {/* Tyoes of ships for User */}
          <Route path='/usercargo' element={<UserCargo/>} /> 
          <Route path='/userBarge' element={<UserBarge/>} />
          <Route path='/userBulk' element={<UserBulk/>} />
          <Route path='/userContainer' element={<UserContainer/>} />
          <Route path='/userFishing' element={<UserFishing/>} />
          <Route path='/userMultipurpose' element={<UserMultipurpose/>} />
          <Route path='/userPassengerFerry' element={<UserPassengerFerry/>} />
          <Route path='/userReefer' element={<UserReefer/>} />
          <Route path='/userRoro' element={<UserRoro/>} />
          <Route path='/userTanker' element={<UserTanker/>} />
          <Route path='/userTug' element={<UserTug/>} />
          <Route path='/userDredger' element={<UserDredger/>} />
          <Route path='/userFloating-Crane' element={<UserFloatingCrane/>} />
          <Route path='/userFloating-Dock' element={<UserFloatingDock/>} />
          <Route path='/userLanding-Craft' element={<UserLandingCraft/>} />
          <Route path='/userYacht' element={<UserYacht/>} />
          <Route path='/userSupplyBoat' element={<UserSupplyBoat/>} />
          <Route path='/userCrewBoat' element={<UserCrewBoat/>} />
          <Route path='/userOthers' element={<UserOthers/>} />

          {/* admin Supply User */}
          {/* <Route path='/userdeck' element={<AdminDeck/>} />
          <Route path='/userenginestore' element={<AdminEngineStore/>} />
          <Route path='/usercabin' element={<AdminCabin/>} />
          <Route path='/usernavigation' element={<AdminNavigation/>} />
          <Route path='/uservalve' element={<AdminValve/>} />
          <Route path='/usercrane' element={<AdminCrane/>} />
          <Route path='/userpumps' element={<AdminPumps/>} />
          <Route path='/userME' element={<AdminME/>} />
          <Route path='/userGen' element={<Generator/>} />
          <Route path='/userlube' element={<LubeOil/>} /> */}



          {/* Supply Equipments */}
          <Route path='/deck' element={<Deck/>} />
          <Route path='/enginestore' element={<EngineStore/>} />
          <Route path='/cabin' element={<Cabin/>} />
          <Route path='/navigation' element={<NavigationEQ/>} />
          <Route path='/valve' element={<ValvePipe/>} />
          <Route path='/crane' element={<Cranes/>} />
          <Route path='/pumps' element={<Pumps/>} />
          <Route path='/ME' element={<MainEngine/>} />
          <Route path='/Gen' element={<Generator/>} />
          <Route path='/lube' element={<LubeOil/>} />



          {/* type of ship grid type */}
          <Route path='/cargo-ship-for-sale' element={<Cargo/>} /> 
          <Route path='/barge-ship-for-sale' element={<Barge/>} />
          <Route path='/bulk-ship-for-sale' element={<Bulk/>} />
          <Route path='/container-ship-for-sale' element={<Container/>} />
          <Route path='/fishing-ship-for-sale' element={<Fishing/>} />
          <Route path='/multipurpose-ship-for-sale' element={<Multipurpose/>} />
          <Route path='/passenger-ferry-ship-for-sale' element={<PassengerFerry/>} />
          <Route path='/reefer-ship-for-sale' element={<Reefer/>} />
          <Route path='/roro-ship-for-sale' element={<Roro/>} />
          <Route path='/tanker-ship-for-sale' element={<Tanker/>} />
          <Route path='/tug-boat-for-sale' element={<Tug/>} />
          <Route path='/dredger-for-sale' element={<Dredger/>} />
          <Route path='/floating-crane-for-sale' element={<FloatingCrane/>} />
          <Route path='/floating-dock-for-sale' element={<FloatingDock/>} />
          <Route path='/landing-craft-for-sale' element={<LandingCraft/>} />
          <Route path='/yacht-for-sale' element={<Yacht/>} />
          <Route path='/supply-boat-for-sale' element={<SupplyBoat/>} />
          <Route path='/crew-boat-for-sale' element={<CrewBoat/>} />
          <Route path='/other-ship-for-sale' element={<Others/>} />
  
 
            {/* single ship */}
          <Route path='/singleShip/:id' element={<SingleShip/>} />
             <Route path="/:vesselType-ship-for-sale/:id" element={<SingleRegShipForSale />} />
          <Route path="/singleRegshipforsale/:id" element={<RedirectWithParams />} />


          <Route path='/singleShiphome/:id' element={<SingleShipHome/>} />
          <Route path='/singleShipReg/:id' element={<SingleShipReg/>} />
          <Route path='/singleShipCharterReg/:id' element={<SingleShipCharterReg/>} />
          <Route path='/singleShipCharter/:id' element={<SingleShipCharter/>} />
          <Route path='/singleShiplogistic/:id' element={<SingleShipLogistic/>} />
          <Route path='/singleShipLogisticReg/:id' element={<SingleShipLogisticReg/>} />

          <Route path='/about' element={<AboutUs/>} />
          <Route path='/contact' element={<ContactUs/>} />
          <Route path='/shipLoc/:id' element={<ShipLocation/>} />
  
          {/* Admin Routes */}
          <Route
            path="/login/*"
            element={
              <PageTransition>
                <Routes>
                  <Route path="/" element={<Signin />} />
                  
                  
                  <Route path="Dashboard" element={<AdminDashboard />} />
                  
                </Routes>
              </PageTransition>
            }
          />
          <Route path="signup" element={<Signup />} />

          {/* Admmin Home */}
          <Route path="/adminHome" element={<AdminHome />} />
          <Route path="/admin/users" element={<AllUsers />} />
          <Route path="/adminShipForSale" element={<AdminShipForSale />} />
          <Route path="/admincontact" element={<AdminContactUs />} />
          {/* home page ship single navigate */}
          <Route path="/adminSingleShipHome/:id" element={<AdminSingleShipHome />} />
          <Route path='/adminsingleRegHome/:id' element={<AdminSingleRegHome/>} />

          {/* ship for admin sale single details */}
          <Route path="/adminSingleShip/:id" element={<AdminSingleShip />} />
          <Route path='/adminsingleRegshipforsale/:id' element={<AdminSingleShipForSale/>} />
          <Route path='/adminChartering' element={<AdminCharter/>} />
          <Route path='/adminSingleCharter/:id' element={<AdminSingleCharter/>} />
          <Route path='/adminLogistic' element={<AdminLogistic/>} />
          <Route path='/adminSupplyEq' element={<AdminSupplyEq/>} />

          {/* Tyoes of ships for admin */}
          <Route path='/admincargo' element={<AdminCargo/>} /> 
          <Route path='/adminBarge' element={<AdminBarge/>} />
          <Route path='/adminBulk' element={<AdminBulk/>} />
          <Route path='/adminContainer' element={<AdminContainer/>} />
          <Route path='/adminFishing' element={<AdminFishing/>} />
          <Route path='/adminMultipurpose' element={<AdminMultipurpose/>} />
          <Route path='/adminPassengerFerry' element={<AdminPassengerFerry/>} />
          <Route path='/adminReefer' element={<AdminReefer/>} />
          <Route path='/adminRoro' element={<AdminRoRo/>} />
          <Route path='/adminTanker' element={<AdminTanker/>} />
          <Route path='/adminTug' element={<AdminTug/>} />
          <Route path='/adminDredger' element={<AdminDredger/>} />
          <Route path='/adminFloating-Crane' element={<AdminFloatingCrane/>} />
          <Route path='/adminFloating-Dock' element={<AdminFloatingDock/>} />
          <Route path='/adminLanding-Craft' element={<AdminLandingCraft/>} />
          <Route path='/adminYacht' element={<AdminYacht/>} />
          <Route path='/adminSupplyBoat' element={<AdminSupplyBoat/>} />
          <Route path='/adminCrewBoat' element={<AdminCrewBoat/>} />
          <Route path='/adminOthers' element={<AdminOthers/>} />

          {/* admin Supply EQ */}
          {/* <Route path='/admindeck' element={<AdminDeck/>} />
          <Route path='/adminenginestore' element={<AdminEngineStore/>} />
          <Route path='/admincabin' element={<AdminCabin/>} />
          <Route path='/adminnavigation' element={<AdminNavigation/>} />
          <Route path='/adminvalve' element={<AdminValve/>} />
          <Route path='/admincrane' element={<AdminCrane/>} />
          <Route path='/adminpumps' element={<AdminPumps/>} />
          <Route path='/adminME' element={<AdminME/>} />
          <Route path='/adminGen' element={<Generator/>} />
          <Route path='/adminlube' element={<LubeOil/>} /> */}
          

                  <Route path="/admin/addShip" element={<AddShip />} />
                  <Route path="/admin/viewShip" element={<ViewShip />} />
                  {/* <Route path="/admin/addCategory" element={<AddCategory />} /> */}
                  <Route path="/admin/addCharter" element={<AddCharter />} />
                  <Route path="/admin/addcargo" element={<AddCargo />} />
                  <Route path="/admin/viewCargo" element={<ViewCargo />} />


                  {/* <Route path="/admin/viewCategory" element={<ViewCategory />} /> */}
                  {/* <Route path="/admin/addsubcategory" element={<AddSubCategory />} /> */}
                  <Route path="/admin/addsEq" element={<AddEq />} />

                  {/* <Route path="/admin/viewSubCategory" element={<ViewSubCat />} /> */}
                  {/* <Route path="/admin/updateViewSubCat/:id" element={<UpdateSubCategory />} /> */}
                  <Route path="/admin/updateViewShip/:id" element={<UpdaetViewShip />} />
                  <Route path="/admin/updateViewShipCustomerRegister/:id" element={<UpdateViewShipCustomerRegister />} />
                  <Route path="/admin/updateViewLogistic/:id" element={<UpdateLogistic />} />

                  <Route path="/admin/shipforsale" element={<VieRegisterShipForSale />} />
                  <Route path="/admin/shipforCharter" element={<ViewShipForCharter />} />
                  <Route path="/admin/updateCharter/:id" element={<UpdateCharter />} />
                  <Route path="/admin/shipforCharterApp" element={<ShipForChartApp />} />

                  <Route path="/admin/LogisticsAppr" element={<LogisticsApprov />} />


                  <Route path="/admin/shipforEq" element={<ViewShipForEquipments />} />
                  <Route path="/admin/shipforEqApp" element={<ShipForEqApp />} />
                  {/* <Route path="/admin/amenities" element={<Amenities />} /> */}
                  <Route path="/admin/profile" element={<Profile />} />

                  <Route path="/admin/Barge" element={<BargeA />} />
                  <Route path="/admin/Bulk" element={<BulkA />} />
                  <Route path="/admin/Cargo" element={<CargoA />} />
                  <Route path="/admin/Container" element={<ContainerA />} />
                  <Route path="/admin/Fishing" element={<FishingA />} />
                  <Route path="/admin/Multipurpose" element={<MultipurposeA />} />
                  <Route path="/admin/Passenger/Ferry" element={<PassengerFerryA />} />
                  <Route path="/admin/Reefer" element={<ReeferA />} />
                  <Route path="/admin/Roro" element={<RoroA />} />
                  <Route path="/admin/Tanker" element={<TankerA />} />
                  <Route path="/admin/Dredger" element={<DredgerA />} />
                  <Route path="/admin/Floating/Crane" element={<FloatingCraneA />} />
                  <Route path="/admin/Floating/Dock" element={<FloatingDockA />} />
                  <Route path="/admin/Landing/Craft" element={<LandingCraftA />} />
                  <Route path="/admin/Yatch" element={<YatchA />} />
                  <Route path="/admin/Tug/Boat" element={<TugBoatA />} />
                  <Route path="/admin/Supply/Boat" element={<SupplyBoatA />} />
                  <Route path="/admin/Crew/Boat" element={<CrewBoatA />} />
                  <Route path="/admin/Other" element={<OtherA />} />


        </Routes>
      </Router>
   
   </>
  );
}

export default App;
